/* ==========================================================================
   WOD.LOL — tri & filtres de collection (sections/wl-collection.liquid)
   Filtrage 100 % client sur les <li data-*> rendus par Liquid :
   ET entre groupes, OU dans un groupe, compteurs à facettes en direct,
   « Voir plus », URL partageable, taille mémorisée d'une collection à l'autre.
   ========================================================================== */
(() => {
  const root = document.querySelector('[data-wl-col]');
  if (!root) return;
  const grid = root.querySelector('[data-grid]');
  if (!grid) return;

  let meta = {};
  try {
    meta = JSON.parse(document.getElementById(root.dataset.meta).textContent);
  } catch (e) {}
  const perPage = meta.perPage || 24;
  const bsRank = new Map((meta.bestSellers || []).map((h, i) => [h, i]));
  const univNames = meta.univers || {};

  const drawer = root.querySelector('[data-drawer]');
  const $ = (s, el) => (el ? el.querySelector(s) : root.querySelector(s) || drawer.querySelector(s));
  const $$ = (s, el = root) => Array.from(el.querySelectorAll(s));
  const fmtEUR = (c) =>
    (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
  const strip = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { v == null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} },
  };

  /* ---------- Normalisation tailles / couleurs ---------- */
  const SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  const normSize = (raw) => {
    let s = String(raw).toUpperCase().replace(/\s+/g, '');
    const eu = s.match(/EU(\d+)/);
    if (eu) return 'EU ' + eu[1];
    if (s === 'XXL') return '2XL';
    if (s === 'XXXL') return '3XL';
    if (/UNIQUE|ONESIZE|^TU$/.test(s)) return 'TU';
    return s;
  };
  const sizeRank = (s) => {
    const i = SIZE_ORDER.indexOf(s);
    if (i > -1) return i;
    const eu = s.match(/EU (\d+)/);
    return eu ? 100 + +eu[1] : 500;
  };

  const COLOR_RULES = [
    ['Vert', /green|vert|khaki|kaki|mint|wintergreen|olive/],
    ['Bleu', /blue|bleu|marine|navy|slate/],
    ['Violet', /lavender|lavande|orchid|violet|purple|lilas|lilac/],
    ['Rose', /pink|rose|bubblegum|watermelon|peche/],
    ['Rouge', /cardinal|red|rouge|bordeaux/],
    ['Jaune', /yellow|jaune|mustard|moutarde/],
    ['Marron', /brown|marron|camel|cameo|sand|choco|tabac/],
    ['Beige', /beige/],
    ['Noir', /black|noir/],
    ['Blanc', /white|blanc|ecru|bone|natur|creme|cream/],
    ['Gris', /gray|grey|gris|charcoal|aluminium|mineral|snow|heather|anthracite/],
  ];
  const COLOR_HEX = {
    Noir: '#111111', Gris: '#8d8d8d', Blanc: '#f3efe6', Beige: '#d9c4a1', Marron: '#7b5337',
    Vert: '#5f7048', Bleu: '#7fa7cc', Violet: '#8b73b9', Rose: '#f19bb5', Rouge: '#b4262f', Jaune: '#f1d35a',
  };
  const COLOR_LABEL = { Blanc: 'Blanc & écru' };
  const colorFamily = (raw) => {
    const s = strip(raw);
    for (const [fam, re] of COLOR_RULES) if (re.test(s)) return fam;
    return null;
  };

  /* ---------- Tuiles vidéo (blocs « video_tile ») ---------- */
  const tiles = $$('[data-vtile]', grid)
    .map((el) => ({ el, pos: +el.dataset.pos || 4 }))
    .sort((a, b) => a.pos - b.pos);
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  const vio =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) =>
            entries.forEach((e) => {
              const v = e.target;
              if (e.isIntersecting && !reduceMotion && !saveData) {
                const p = v.play();
                if (p && p.catch) p.catch(() => {});
              } else v.pause();
            }),
          { threshold: 0.35 }
        )
      : null;
  tiles.forEach((t) => {
    const v = t.el.querySelector('video');
    if (vio && v) vio.observe(v);
    // 720p introuvable → 1080p d'origine
    const srcEl = v && v.querySelector('source[data-fallback]');
    if (srcEl && srcEl.dataset.fallback && srcEl.dataset.fallback !== srcEl.src)
      srcEl.addEventListener('error', () => {
        srcEl.src = srcEl.dataset.fallback;
        srcEl.removeAttribute('data-fallback');
        const playing = !v.paused;
        v.load();
        if (playing) v.play().catch(() => {});
      }, { once: true });
    const snd = t.el.querySelector('[data-vsound]');
    if (snd && v)
      snd.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const on = v.muted;
        // un seul son à la fois
        tiles.forEach((o) => {
          const ov = o.el.querySelector('video');
          if (ov && ov !== v) ov.muted = true;
          const ob = o.el.querySelector('[data-vsound]');
          if (ob && ob !== snd) ob.setAttribute('aria-pressed', 'false');
        });
        v.muted = !on;
        if (on) v.play().catch(() => {});
        snd.setAttribute('aria-pressed', String(on));
        snd.setAttribute('aria-label', on ? 'Couper le son' : 'Activer le son');
      });
  });
  const placeTiles = (shownList) => {
    // éditorial seulement sans filtre actif (comme Gymshark / Alo)
    const show = activeCount() === 0;
    tiles.forEach((t) => {
      const anchor = shownList[t.pos]; // insérée avant le (pos+1)e produit visible
      if (!show || shownList.length < t.pos) {
        t.el.hidden = true;
        const v = t.el.querySelector('video');
        if (v) v.pause();
        return;
      }
      t.el.hidden = false;
      if (anchor) grid.insertBefore(t.el, anchor.el);
      else grid.appendChild(t.el);
    });
  };

  /* ---------- Lecture des fiches ---------- */
  const split = (s) => (s || '').split('|').map((x) => x.trim()).filter(Boolean);
  const items = $$('.wl-item', grid).map((el) => {
    const d = el.dataset;
    const sizes = new Set(split(d.sizes).map(normSize));
    const colors = new Set(split(d.colors).map(colorFamily).filter(Boolean));
    return {
      el,
      idx: +d.idx,
      handle: d.handle,
      cat: d.cat ? [d.cat] : [],
      fit: d.fit ? [d.fit] : [],
      gen: d.gen ? [d.gen] : [],
      fin: d.fin ? [d.fin] : [],
      wt: d.wt ? [d.wt] : [],
      gsm: +d.gsm || 0,
      univ: split(d.univ).filter((h) => univNames[h]),
      size: [...sizes],
      color: [...colors],
      price: +d.price || 0,
      cmp: +d.cmp || 0,
      pub: +d.pub || 0,
      avail: d.avail === '1',
      outlet: d.outlet === '1',
      rating: +d.rating || 0,
      rc: +d.rc || 0,
      bs: bsRank.has(d.handle) ? bsRank.get(d.handle) : 999,
    };
  });
  items.forEach((it) => {
    it.promo = it.cmp > it.price;
    it.isNew = meta.newAfter && it.pub > meta.newAfter;
  });
  if (!items.length) return;

  /* Ligne d'info sous chaque carte : « Oversize · Snow wash » (les coloris sont déjà dans Glo Swatch) */
  items.forEach((it) => {
    const p = it.el.querySelector('[data-cmeta]');
    if (!p) return;
    const bits = [];
    if (it.fit[0]) bits.push(it.fit[0]);
    if (it.fin[0] && it.fin[0] !== 'Uni') bits.push(it.fin[0]);
    if (it.gsm) bits.push(it.gsm + ' g/m²');
    p.textContent = bits.join(' · ');
    // juste sous le titre, avant étoiles / prix / pastilles
    const h = it.el.querySelector('.card__heading.h5') || it.el.querySelector('.card__heading');
    if (h && bits.length) h.after(p);
  });

  /* ---------- Groupes ---------- */
  const CAT_ORDER = ['T-shirt', 'Débardeur', 'Crop top', 'Sweat & hoodie', 'Veste', 'Short', 'Accessoire'];
  const CAT_PLURAL = {
    'T-shirt': 'T-shirts', 'Débardeur': 'Débardeurs', 'Crop top': 'Crop tops', 'Sweat & hoodie': 'Sweats & hoodies',
    Veste: 'Vestes', Short: 'Shorts', Accessoire: 'Accessoires',
  };
  const FIT_DESC = {
    Oversize: 'Ample, épaules tombantes, tombe plus bas',
    Boxy: 'Large et plus court, effet carré',
    Classique: 'Coupe droite, près du corps',
    'Décontractée': 'De l’aisance sans excès',
  };
  const WT_DESC = {
    'Léger': 'Moins de 200 g/m² · frais, idéal été',
    Medium: '200 à 279 g/m² · le polyvalent',
    'Épais': '280 g/m² et plus · tombé premium, ne colle pas',
  };
  const GROUPS = [
    { k: 'cat', label: 'Catégorie', ui: 'chips', param: 'cat', order: CAT_ORDER, name: (v) => CAT_PLURAL[v] || v },
    { k: 'size', label: 'Taille', ui: 'sizes', param: 'taille', hint: 'Seulement les modèles dispo dans ta taille' },
    { k: 'color', label: 'Couleur', ui: 'swatches', param: 'couleur', name: (v) => COLOR_LABEL[v] || v },
    { k: 'fit', label: 'Coupe', ui: 'cards', param: 'coupe', order: ['Oversize', 'Boxy', 'Classique', 'Décontractée'], desc: FIT_DESC },
    { k: 'wt', label: 'Épaisseur', ui: 'cards', param: 'epaisseur', order: ['Léger', 'Medium', 'Épais'], desc: WT_DESC },
    { k: 'fin', label: 'Finition', ui: 'chips', param: 'finition', order: ['Uni', 'Délavé', 'Snow wash', 'Acid wash', 'Tie-dye', 'Vintage'] },
    { k: 'gen', label: 'Pour qui', ui: 'chips', param: 'pour', order: ['Mixte', 'Femme', 'Homme', 'Enfant'] },
    { k: 'univ', label: 'Univers', ui: 'chips', param: 'univers', name: (v) => univNames[v] || v },
  ];
  const TOGGLES = [
    { k: 'promo', label: 'En promo', param: 'promo', test: (it) => it.promo },
    { k: 'isNew', label: 'Nouveautés', param: 'nouveau', test: (it) => it.isNew },
    { k: 'avail', label: 'En stock uniquement', param: 'dispo', test: (it) => it.avail },
  ];
  const SORTS = [
    { k: 'reco', label: 'Recommandés' },
    { k: 'new', label: 'Nouveautés' },
    { k: 'best', label: 'Meilleures ventes' },
    { k: 'rating', label: 'Mieux notés' },
    { k: 'price-asc', label: 'Prix croissant' },
    { k: 'price-desc', label: 'Prix décroissant' },
    { k: 'promo', label: 'Plus grosse remise' },
  ];

  const priceMin = Math.floor(Math.min(...items.map((i) => i.price)) / 100) * 100;
  const priceMax = Math.ceil(Math.max(...items.map((i) => i.price)) / 100) * 100;

  /* ---------- État ---------- */
  const state = {
    sel: Object.fromEntries(GROUPS.map((g) => [g.k, new Set()])),
    tog: Object.fromEntries(TOGGLES.map((t) => [t.k, false])),
    price: null, // [min, max] en centimes
    sort: 'reco',
    page: 1,
  };

  const readURL = () => {
    const p = new URLSearchParams(location.search);
    GROUPS.forEach((g) => {
      const v = p.get(g.param);
      if (v) v.split(',').filter(Boolean).forEach((x) => state.sel[g.k].add(x));
    });
    TOGGLES.forEach((t) => (state.tog[t.k] = p.get(t.param) === '1'));
    const pr = p.get('prix');
    if (pr && /^\d+-\d+$/.test(pr)) {
      const [a, b] = pr.split('-').map((x) => +x * 100);
      state.price = [a, b];
    }
    const s = p.get('tri');
    if (s && SORTS.some((x) => x.k === s)) state.sort = s;
  };
  const writeURL = () => {
    const p = new URLSearchParams(location.search);
    GROUPS.forEach((g) => {
      const v = [...state.sel[g.k]];
      v.length ? p.set(g.param, v.join(',')) : p.delete(g.param);
    });
    TOGGLES.forEach((t) => (state.tog[t.k] ? p.set(t.param, '1') : p.delete(t.param)));
    state.price ? p.set('prix', state.price[0] / 100 + '-' + state.price[1] / 100) : p.delete('prix');
    state.sort !== 'reco' ? p.set('tri', state.sort) : p.delete('tri');
    p.delete('page');
    const qs = p.toString().replace(/%2C/g, ',');
    history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  };

  /* ---------- Moteur ---------- */
  const passGroup = (it, g) => {
    const s = state.sel[g.k];
    if (!s.size) return true;
    return it[g.k].some((v) => s.has(v));
  };
  const passOthers = (it, except) => {
    for (const g of GROUPS) if (g.k !== except && !passGroup(it, g)) return false;
    for (const t of TOGGLES) if (t.k !== except && state.tog[t.k] && !t.test(it)) return false;
    if (except !== 'price' && state.price && (it.price < state.price[0] || it.price > state.price[1])) return false;
    return true;
  };
  const activeCount = () =>
    GROUPS.reduce((n, g) => n + state.sel[g.k].size, 0) +
    TOGGLES.filter((t) => state.tog[t.k]).length +
    (state.price ? 1 : 0);

  const sorters = {
    // ordre manuel de l'admin respecté ; sinon les best-sellers d'abord
    // ordre de la collection (admin) respecté ; seul /collections/all remonte les best-sellers
    reco: meta.rankBest
      ? (a, b) => a.outlet - b.outlet || b.avail - a.avail || a.bs - b.bs || a.idx - b.idx
      : (a, b) => a.outlet - b.outlet || b.avail - a.avail || a.idx - b.idx,
    new: (a, b) => b.pub - a.pub || a.idx - b.idx,
    best: (a, b) => a.bs - b.bs || a.outlet - b.outlet || a.idx - b.idx,
    rating: (a, b) => b.rating * Math.log1p(b.rc) - a.rating * Math.log1p(a.rc) || a.bs - b.bs || a.idx - b.idx,
    'price-asc': (a, b) => a.price - b.price || a.idx - b.idx,
    'price-desc': (a, b) => b.price - a.price || a.idx - b.idx,
    promo: (a, b) => (b.cmp ? (b.cmp - b.price) / b.cmp : 0) - (a.cmp ? (a.cmp - a.price) / a.cmp : 0) || a.idx - b.idx,
  };
  // Dans l'Outlet, pas de relégation des articles outlet
  if (meta.isOutletCollection) sorters.reco = (a, b) => b.avail - a.avail || a.idx - b.idx;

  // Tri Recommandés : les dernières sorties en tête, un best-seller (ordre de la collection) toutes les N
  const mixHead = (res) => {
    const mx = meta.mix;
    if (!mx) return res;
    const ok = (it) => it.avail && !it.outlet;
    const fresh = res.filter((it) => ok(it) && it.pub > mx.after).sort((a, b) => b.pub - a.pub || a.idx - b.idx).slice(0, mx.max);
    if (!fresh.length) return res;
    const isFresh = new Set(fresh);
    const rest = res.filter((it) => !isFresh.has(it));
    const head = [];
    let r = 0;
    fresh.forEach((it, i) => {
      head.push(it);
      if ((i + 1) % mx.every === 0 && rest[r] && ok(rest[r])) head.push(rest[r++]);
    });
    return head.concat(rest.slice(r));
  };

  let lastShown = new Set();
  const apply = (opts = {}) => {
    let res = items.filter((it) => passOthers(it, null)).sort(sorters[state.sort]);
    if (state.sort === 'reco') res = mixHead(res);
    const limit = perPage * state.page;
    const frag = document.createDocumentFragment();
    const nowShown = new Set();
    let order = 0;
    res.forEach((it, i) => {
      const show = i < limit;
      it.el.hidden = !show;
      if (show) {
        nowShown.add(it);
        if (!lastShown.has(it) || opts.reflow) {
          it.el.classList.remove('wl-in');
          it.el.style.setProperty('--d', Math.min(order++, 12) * 35 + 'ms');
          void it.el.offsetWidth;
          it.el.classList.add('wl-in');
        }
      }
      frag.appendChild(it.el);
    });
    items.forEach((it) => {
      if (!res.includes(it)) {
        it.el.hidden = true;
        frag.appendChild(it.el);
      }
    });
    grid.appendChild(frag);
    lastShown = nowShown;
    placeTiles(res.slice(0, limit));

    // Compteurs
    const n = res.length;
    const lbl = n > 1 ? 'produits' : 'produit';
    $('[data-count]').textContent = n;
    $('[data-count-label]').textContent = lbl;
    $('[data-apply-n]').textContent = n;
    $('[data-apply-label]').textContent = lbl;
    const an = activeCount();
    [$('[data-active-n]'), $('[data-active-n2]')].forEach((b) => {
      b.textContent = an;
      b.hidden = !an;
    });
    $('[data-sort-label]').textContent = SORTS.find((s) => s.k === state.sort).label;

    // Voir plus
    const more = $('[data-more]');
    if (more) {
      const shown = Math.min(limit, n);
      more.hidden = n <= perPage;
      $('[data-shown]').textContent = shown;
      $('[data-total]').textContent = n;
      $('[data-more-fill]').style.width = (n ? (shown / n) * 100 : 0) + '%';
      $('[data-more-btn]').hidden = shown >= n;
    }

    // Vide
    const empty = $('[data-empty]');
    empty.classList.toggle('is-on', n === 0);
    if (n === 0) renderSuggestions();

    renderGroups();
    renderActive();
    renderQuick();
    if (!opts.silentURL) writeURL();
  };

  /* ---------- Rendu : panneau ---------- */
  const groupsEl = $('[data-groups]');
  const openGroups = new Set(['cat', 'size', 'color', 'fit', 'wt']);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  const facetCounts = (g) => {
    const counts = new Map();
    items.forEach((it) => {
      if (!passOthers(it, g.k)) return;
      it[g.k].forEach((v) => counts.set(v, (counts.get(v) || 0) + 1));
    });
    // valeurs présentes dans la collection (même à 0 avec les filtres actuels)
    const all = new Set();
    items.forEach((it) => it[g.k].forEach((v) => all.add(v)));
    let vals = [...all];
    if (g.k === 'size') vals.sort((a, b) => sizeRank(a) - sizeRank(b));
    else if (g.order) vals.sort((a, b) => (g.order.indexOf(a) + 1 || 99) - (g.order.indexOf(b) + 1 || 99));
    else if (g.k === 'color') vals.sort((a, b) => Object.keys(COLOR_HEX).indexOf(a) - Object.keys(COLOR_HEX).indexOf(b));
    else vals.sort((a, b) => (counts.get(b) || 0) - (counts.get(a) || 0));
    return { vals, counts };
  };

  const renderGroups = () => {
    const scroll = groupsEl.scrollTop;
    let html = '';

    // Toggles rapides
    const togHtml = TOGGLES.map((t) => {
      const c = items.filter((it) => passOthers(it, t.k) && t.test(it)).length;
      const all = items.some(t.test);
      if (!all || (t.k === 'avail' && items.every((it) => it.avail))) return '';
      return `<button type="button" class="wl-tog" role="switch" aria-checked="${state.tog[t.k]}" data-tog="${t.k}" ${!c && !state.tog[t.k] ? 'disabled' : ''}>
        <span class="wl-tog__sw" aria-hidden="true"></span><span class="wl-tog__l">${t.label}</span><span class="wl-tog__c">${c}</span></button>`;
    }).join('');
    if (togHtml) html += `<div class="wl-fg wl-fg--toggles">${togHtml}</div>`;

    GROUPS.forEach((g) => {
      const { vals, counts } = facetCounts(g);
      if (vals.length < 2 && !state.sel[g.k].size) return;
      const sel = state.sel[g.k];
      const open = openGroups.has(g.k) || sel.size;
      let body = '';
      if (g.ui === 'sizes') {
        const my = store.get('wl-size');
        const btn = (v) => {
          const c = counts.get(v) || 0;
          return `<button type="button" class="wl-size${my === v ? ' is-mine' : ''}" aria-pressed="${sel.has(v)}" data-g="size" data-v="${esc(v)}" ${!c && !sel.has(v) ? 'disabled' : ''}>
            <span>${esc(v.replace('EU ', ''))}</span><small>${c}</small></button>`;
        };
        const wear = vals.filter((v) => !v.startsWith('EU '));
        const shoes = vals.filter((v) => v.startsWith('EU '));
        body = `<p class="wl-fg__hint">${g.hint}</p>` +
          (wear.length ? `<div class="wl-sizes">${wear.map(btn).join('')}</div>` : '') +
          (shoes.length ? `<p class="wl-sizes__sub">Pointures (EU)</p><div class="wl-sizes">${shoes.map(btn).join('')}</div>` : '');
      } else if (g.ui === 'swatches') {
        body = '<div class="wl-sw">' + vals.map((v) => {
          const c = counts.get(v) || 0;
          return `<button type="button" class="wl-swatch" aria-pressed="${sel.has(v)}" data-g="color" data-v="${esc(v)}" ${!c && !sel.has(v) ? 'disabled' : ''}>
            <span class="wl-swatch__dot" style="--c:${COLOR_HEX[v] || '#777'}"></span><span class="wl-swatch__l">${esc(g.name(v))}</span><small>${c}</small></button>`;
        }).join('') + '</div>';
      } else if (g.ui === 'cards') {
        body = '<div class="wl-fits">' + vals.map((v) => {
          const c = counts.get(v) || 0;
          return `<button type="button" class="wl-fit" aria-pressed="${sel.has(v)}" data-g="${g.k}" data-v="${esc(v)}" ${!c && !sel.has(v) ? 'disabled' : ''}>
            <span class="wl-fit__ico wl-fit__ico--${strip(v).replace(/[^a-z]/g, '')}" aria-hidden="true"></span>
            <span class="wl-fit__t">${esc(v)} <small>${c}</small></span>
            <span class="wl-fit__d">${(g.desc && g.desc[v]) || ''}</span></button>`;
        }).join('') + '</div>';
      } else {
        body = '<div class="wl-chips">' + vals.map((v) => {
          const c = counts.get(v) || 0;
          return `<button type="button" class="wl-chip" aria-pressed="${sel.has(v)}" data-g="${g.k}" data-v="${esc(v)}" ${!c && !sel.has(v) ? 'disabled' : ''}>
            ${esc(g.name ? g.name(v) : v)}<small>${c}</small></button>`;
        }).join('') + '</div>';
      }
      html += `<details class="wl-fg" data-group="${g.k}" ${open ? 'open' : ''}>
        <summary><span class="wl-fg__t">${g.label}${sel.size ? `<i>${sel.size}</i>` : ''}</span><span class="wl-fg__plus" aria-hidden="true"></span></summary>
        <div class="wl-fg__b">${body}</div></details>`;
    });

    // Prix
    if (priceMax - priceMin >= 500) {
      const [a, b] = state.price || [priceMin, priceMax];
      const counts = items.filter((it) => passOthers(it, 'price'));
      const bins = 12;
      const hist = new Array(bins).fill(0);
      counts.forEach((it) => {
        const i = Math.min(bins - 1, Math.floor(((it.price - priceMin) / (priceMax - priceMin || 1)) * bins));
        hist[i]++;
      });
      const hmax = Math.max(1, ...hist);
      html += `<details class="wl-fg" data-group="price" ${state.price || openGroups.has('price') ? 'open' : ''}>
        <summary><span class="wl-fg__t">Prix${state.price ? '<i>1</i>' : ''}</span><span class="wl-fg__plus" aria-hidden="true"></span></summary>
        <div class="wl-fg__b"><div class="wl-price">
          <div class="wl-price__hist">${hist.map((h, i) => {
            const lo = priceMin + ((priceMax - priceMin) * i) / bins;
            const on = lo + (priceMax - priceMin) / bins > a && lo < b;
            return `<span style="--h:${(h / hmax) * 100}%" class="${on ? 'is-on' : ''}"></span>`;
          }).join('')}</div>
          <div class="wl-price__range" style="--an:${(a - priceMin) / (priceMax - priceMin)};--bn:${(b - priceMin) / (priceMax - priceMin)}">
            <input type="range" min="${priceMin / 100}" max="${priceMax / 100}" step="1" value="${a / 100}" data-price="0" aria-label="Prix minimum">
            <input type="range" min="${priceMin / 100}" max="${priceMax / 100}" step="1" value="${b / 100}" data-price="1" aria-label="Prix maximum">
          </div>
          <p class="wl-price__v"><span data-pv0>${fmtEUR(a)}</span><span data-pv1>${fmtEUR(b)}</span></p>
        </div></div></details>`;
    }

    groupsEl.innerHTML = html;
    groupsEl.scrollTop = scroll;
  };

  /* ---------- Rendu : filtres actifs ---------- */
  const activeEl = $('[data-active]');
  const chipsOfActive = () => {
    const out = [];
    GROUPS.forEach((g) =>
      state.sel[g.k].forEach((v) => out.push({ g: g.k, v, label: g.name ? g.name(v) : v, dot: g.k === 'color' ? COLOR_HEX[v] : null }))
    );
    TOGGLES.forEach((t) => state.tog[t.k] && out.push({ t: t.k, label: t.label }));
    if (state.price) out.push({ price: 1, label: fmtEUR(state.price[0]) + ' – ' + fmtEUR(state.price[1]) });
    return out;
  };
  const chipAttrs = (c) =>
    c.g ? `data-rm-g="${c.g}" data-rm-v="${esc(c.v)}"` : c.t ? `data-rm-t="${c.t}"` : 'data-rm-price="1"';
  const renderActive = () => {
    const list = chipsOfActive();
    activeEl.hidden = !list.length;
    activeEl.innerHTML = list.map((c) =>
      `<button type="button" class="wl-achip" ${chipAttrs(c)}>${c.dot ? `<span class="wl-achip__dot" style="--c:${c.dot}"></span>` : ''}${esc(c.label)}<span class="wl-achip__x" aria-label="Retirer">×</span></button>`
    ).join('') + (list.length > 1 ? '<button type="button" class="wl-aclear" data-clear>Tout effacer</button>' : '');
  };

  /* ---------- Rendu : puces rapides (barre) ---------- */
  const quickEl = $('[data-quick]');
  const renderQuick = () => {
    let html = '';
    const my = store.get('wl-size');
    const sizeG = facetCounts(GROUPS[1]);
    if (my && sizeG.vals.includes(my)) {
      const on = state.sel.size.has(my) && state.sel.size.size === 1;
      html += `<button type="button" class="wl-q wl-q--me" aria-pressed="${on}" data-q-size="${esc(my)}">
        <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M8 1.5l1.9 4 4.3.4-3.3 2.9 1 4.2L8 10.8 4.1 13l1-4.2L1.8 5.9l4.3-.4z" fill="currentColor"/></svg>
        Ma taille · ${esc(my)}</button>`;
    }
    // catégories s'il y en a plusieurs, sinon coupes
    let g = GROUPS[0];
    let fc = facetCounts(g);
    if (fc.vals.length < 2) {
      g = GROUPS[3];
      fc = facetCounts(g);
    }
    if (fc.vals.length >= 2) {
      html += fc.vals.map((v) => {
        const c = fc.counts.get(v) || 0;
        const on = state.sel[g.k].has(v);
        return `<button type="button" class="wl-q" aria-pressed="${on}" data-g="${g.k}" data-v="${esc(v)}" ${!c && !on ? 'disabled' : ''}>${esc(g.name ? g.name(v) : v)}<small>${c}</small></button>`;
      }).join('');
    }
    if (items.some((it) => it.promo)) {
      html += `<button type="button" class="wl-q wl-q--sale" aria-pressed="${state.tog.promo}" data-tog="promo">En promo</button>`;
    }
    html += `<button type="button" class="wl-q wl-q--ghost" data-open-filters data-focus="size">Taille</button>`;
    html += `<button type="button" class="wl-q wl-q--ghost" data-open-filters data-focus="color">Couleur</button>`;
    const sx = quickEl.scrollLeft;
    quickEl.innerHTML = html;
    quickEl.scrollLeft = sx;
  };

  /* ---------- Suggestions quand 0 résultat ---------- */
  const renderSuggestions = () => {
    const box = $('[data-empty-sug]');
    const sug = chipsOfActive().map((c) => {
      // simule le retrait de ce filtre
      const snap = JSON.stringify([...Object.entries(state.sel)].map(([k, s]) => [k, [...s]]));
      const tog = { ...state.tog };
      const price = state.price;
      if (c.g) state.sel[c.g].delete(c.v);
      else if (c.t) state.tog[c.t] = false;
      else state.price = null;
      const n = items.filter((it) => passOthers(it, null)).length;
      JSON.parse(snap).forEach(([k, arr]) => (state.sel[k] = new Set(arr)));
      state.tog = tog;
      state.price = price;
      return { c, n };
    }).filter((s) => s.n > 0).sort((a, b) => b.n - a.n);
    box.innerHTML = sug.map(({ c, n }) =>
      `<button type="button" class="wl-achip" ${chipAttrs(c)}>Sans « ${esc(c.label)} » <b>${n}</b></button>`
    ).join('') || '<button type="button" class="wl-pill wl-pill--light" data-clear>Tout effacer</button>';
  };

  /* ---------- Actions ---------- */
  const toggleVal = (g, v) => {
    const s = state.sel[g];
    s.has(v) ? s.delete(v) : s.add(v);
    if (g === 'size') {
      // une seule taille choisie = on la mémorise pour les autres collections
      if (s.size === 1) store.set('wl-size', [...s][0]);
    }
    state.page = 1;
    apply();
  };

  const onClick = (e) => {
    const b = e.target.closest('button, [data-close-filters]');
    if (!b) return;
    if (b.matches('[data-open-filters]')) return openDrawer(b.dataset.focus);
    if (b.matches('[data-close-filters]')) return closeDrawer();
    if (b.matches('[data-clear]')) {
      GROUPS.forEach((g) => state.sel[g.k].clear());
      TOGGLES.forEach((t) => (state.tog[t.k] = false));
      state.price = null;
      state.page = 1;
      return apply();
    }
    if (b.dataset.g && b.dataset.v != null) return toggleVal(b.dataset.g, b.dataset.v);
    if (b.dataset.qSize) {
      const v = b.dataset.qSize;
      const on = state.sel.size.has(v) && state.sel.size.size === 1;
      state.sel.size.clear();
      if (!on) state.sel.size.add(v);
      state.page = 1;
      return apply();
    }
    if (b.dataset.tog) {
      state.tog[b.dataset.tog] = !state.tog[b.dataset.tog];
      state.page = 1;
      return apply();
    }
    if (b.dataset.rmG) return toggleVal(b.dataset.rmG, b.dataset.rmV);
    if (b.dataset.rmT) {
      state.tog[b.dataset.rmT] = false;
      return apply();
    }
    if (b.dataset.rmPrice) {
      state.price = null;
      return apply();
    }
    if (b.matches('[data-more-btn]')) {
      // apply() ré-insère toute la grille → le navigateur perdait la position (saut de ~4000 px
      // vers le haut sur mobile, vu en « dead click » dans PostHog). On la restaure tout de suite.
      const y = scrollY;
      state.page++;
      apply({ silentURL: true });
      scrollTo({ top: y, behavior: 'instant' });
      return;
    }
    if (b.matches('[data-sort-btn]')) return toggleSort();
    if (b.dataset.sort) {
      state.sort = b.dataset.sort;
      state.page = 1;
      toggleSort(false);
      apply({ reflow: true });
      const bar = $('[data-bar]');
      const y = grid.getBoundingClientRect().top + scrollY - bar.offsetHeight - stickyTop() - 12;
      if (scrollY > y) scrollTo({ top: y, behavior: 'smooth' });
    }
  };
  root.addEventListener('click', onClick);

  // Ouverture/fermeture des groupes mémorisée entre deux rendus
  groupsEl.addEventListener('toggle', (e) => {
    const d = e.target.closest('details[data-group]');
    if (!d) return;
    d.open ? openGroups.add(d.dataset.group) : openGroups.delete(d.dataset.group);
  }, true);

  // Curseurs prix : visuel en direct, filtrage au relâchement
  groupsEl.addEventListener('input', (e) => {
    const r = e.target.closest('[data-price]');
    if (!r) return;
    const wrap = r.parentElement;
    const [i0, i1] = wrap.querySelectorAll('input');
    let a = +i0.value, b = +i1.value;
    if (a > b) r.dataset.price === '0' ? (i0.value = a = b) : (i1.value = b = a);
    const span = priceMax - priceMin;
    wrap.style.setProperty('--an', (a * 100 - priceMin) / span);
    wrap.style.setProperty('--bn', (b * 100 - priceMin) / span);
    $('[data-pv0]').textContent = fmtEUR(a * 100);
    $('[data-pv1]').textContent = fmtEUR(b * 100);
  });
  groupsEl.addEventListener('change', (e) => {
    const r = e.target.closest('[data-price]');
    if (!r) return;
    const [i0, i1] = r.parentElement.querySelectorAll('input');
    const a = +i0.value * 100, b = +i1.value * 100;
    state.price = a <= priceMin && b >= priceMax ? null : [a, b];
    state.page = 1;
    apply();
  });

  /* ---------- Tri ---------- */
  const sortBtn = $('[data-sort-btn]');
  const sortMenu = $('[data-sort-menu]');
  sortMenu.innerHTML = SORTS.map((s) => `<li><button type="button" role="option" data-sort="${s.k}">${s.label}</button></li>`).join('');
  // sorti dans <body> : le backdrop-filter de la barre piégerait un position:fixed
  document.body.appendChild(sortMenu);
  sortMenu.classList.add('wl-col-sortmenu');
  sortMenu.addEventListener('click', onClick);
  const placeSort = () => {
    if (innerWidth < 750) {
      sortMenu.style.top = sortMenu.style.right = '';
      return;
    }
    const r = sortBtn.getBoundingClientRect();
    sortMenu.style.top = r.bottom + 8 + 'px';
    sortMenu.style.right = document.documentElement.clientWidth - r.right + 'px';
  };
  addEventListener('scroll', () => !sortMenu.hidden && placeSort(), { passive: true });
  const toggleSort = (force) => {
    const open = force ?? sortMenu.hidden;
    if (open) placeSort();
    sortMenu.hidden = !open;
    document.documentElement.classList.toggle('wl-sort-open', open);
    sortBtn.setAttribute('aria-expanded', open);
    $$('[data-sort]', sortMenu).forEach((b) => b.setAttribute('aria-selected', b.dataset.sort === state.sort));
    if (open) requestAnimationFrame(() => sortMenu.classList.add('is-open'));
    else sortMenu.classList.remove('is-open');
  };
  document.addEventListener('click', (e) => {
    if (!sortMenu.hidden && !e.target.closest('.wl-sort, .wl-col-sortmenu')) toggleSort(false);
  });

  /* ---------- Tiroir ---------- */
  const panel = drawer.querySelector('.wl-fd__panel');
  // sorti de la section pour échapper aux overflow/transform parents
  document.body.appendChild(drawer);
  drawer.addEventListener('click', onClick);

  let lastFocus = null;
  const openDrawer = (focus) => {
    lastFocus = document.activeElement;
    if (focus) openGroups.add(focus);
    renderGroups();
    drawer.hidden = false;
    document.documentElement.classList.add('wl-fd-lock');
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
    panel.focus({ preventScroll: true });
    if (focus) {
      const g = groupsEl.querySelector(`[data-group="${focus}"]`);
      if (g) setTimeout(() => g.scrollIntoView({ block: 'start', behavior: 'smooth' }), 260);
    }
  };
  const closeDrawer = () => {
    if (drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('wl-fd-lock');
    panel.style.transform = '';
    setTimeout(() => (drawer.hidden = true), 420);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
    const top = grid.getBoundingClientRect().top;
    if (top < 0) scrollTo({ top: top + scrollY - $('[data-bar]').offsetHeight - stickyTop() - 12, behavior: 'smooth' });
  };
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (!sortMenu.hidden) toggleSort(false);
    else closeDrawer();
  });

  // Bottom sheet : glisser vers le bas pour fermer (mobile)
  let dragY = null;
  panel.addEventListener('touchstart', (e) => {
    if (innerWidth >= 750) return;
    const inHead = e.target.closest('.wl-fd__head, .wl-fd__grab');
    if (!inHead && groupsEl.scrollTop > 0) return;
    if (!inHead) return;
    dragY = e.touches[0].clientY;
    panel.style.transition = 'none';
  }, { passive: true });
  panel.addEventListener('touchmove', (e) => {
    if (dragY == null) return;
    const dy = Math.max(0, e.touches[0].clientY - dragY);
    panel.style.transform = `translateY(${dy}px)`;
  }, { passive: true });
  panel.addEventListener('touchend', (e) => {
    if (dragY == null) return;
    const dy = e.changedTouches[0].clientY - dragY;
    dragY = null;
    panel.style.transition = '';
    if (dy > 110) closeDrawer();
    else panel.style.transform = '';
  });

  /* ---------- Barre collante sous le header ---------- */
  const header = document.querySelector('.section-header');
  const stickyTop = () => {
    if (!header) return 0;
    const pos = getComputedStyle(header).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    const b = header.getBoundingClientRect().bottom;
    return b > 0 && b < 240 ? b : 0;
  };
  let raf = 0;
  const syncTop = () => {
    raf = 0;
    root.style.setProperty('--wl-top', stickyTop() + 'px');
    const bar = $('[data-bar]');
    bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= stickyTop() + 1 && scrollY > 10);
  };
  let settle = 0;
  addEventListener('scroll', () => {
    raf || (raf = requestAnimationFrame(syncTop));
    clearTimeout(settle);
    settle = setTimeout(syncTop, 380); // le header Dawn finit son animation (masqué / révélé)
  }, { passive: true });
  addEventListener('resize', syncTop);
  addEventListener('load', syncTop);

  /* ---------- Go ---------- */
  readURL();
  apply({ silentURL: true });
  syncTop();
})();
